export default "__VITE_ASSET__n0se$v_O__"